import CTAButton from '../../../../CTAButton';
import OcLabel from '../../../../ComponentLibrary/input-elements/oc-label';
import NumberInput from '../../../../ComponentLibrary/input-elements/oc-numeric-input';
import { QuestionWrapper } from '../../styles';
import { DropdownField, RadioList, Section, YesNo } from '../shared/formControls';

/* eslint-disable react/prop-types */
export const Sidebar = ({
  calcId,
  framingType,
  setFramingType,
  setCavityRSI,
  onCenterSpacing,
  setOnCenterSpacing,
  onCenterSpacingOptions,
  cavityRSI,
  insulationOptions,
  gypsumBoardThickness,
  setGypsumBoardThickness,
  hasWoodStrapping,
  setHasWoodStrapping,
  hasVapourBarrier,
  setHasVapourBarrier,
  aboveTrussRSI,
  setAboveTrussRSI,
  onCalculate,
  onReset,
  hasLocation,
  t,
}) => (
  <>
    <Section title={t('thermal_calculator.non_continuous_layers')}>
      <div>
        <OcLabel text={t('thermal_calculator.framing_type')} />
        <RadioList
          name={`framing-type-${calcId}`}
          value={framingType}
          onChange={ft => {
            setFramingType(ft);
            setCavityRSI('');
          }}
          options={[
            { value: '2x4', label: t('thermal_calculator.roofs_below_attics.wood_truss_2_4') },
            { value: '2x6', label: t('thermal_calculator.roofs_below_attics.wood_truss_2_6') },
          ]}
        />
      </div>

      <div>
        <OcLabel forId="on-center-spacing" text={t('thermal_calculator.roofs_below_attics.framing_on_center')} />
        <DropdownField
          id={`on-center-spacing-${calcId}`}
          value={onCenterSpacing}
          onChange={e => {
            setOnCenterSpacing(e.target.value);
          }}
          style={{ width: '100%', marginTop: 6, padding: '8px 10px' }}
          options={Object.entries(onCenterSpacingOptions).map(([value, text]) => ({
            value,
            text,
          }))}
        />
      </div>

      <div>
        <OcLabel
          forId={`cavityRSI-${calcId}`}
          text={t('thermal_calculator.floors_over_unheated_spaces.cavity_nominal_rsi')}
        />
        <DropdownField
          id={`cavityRSI-${calcId}`}
          value={cavityRSI}
          onChange={e => {
            setCavityRSI(e.target.value);
          }}
          style={{ width: '100%', marginTop: 6, padding: '8px 10px' }}
          options={insulationOptions}
        />
      </div>
    </Section>

    <Section title={t('thermal_calculator.continuous_layers')}>
      <QuestionWrapper>
        <OcLabel text={t('thermal_calculator.roofs_below_attics.gypsum_board_thickness')} />
        <RadioList
          name={`gypsum-thickness-${calcId}`}
          value={gypsumBoardThickness}
          onChange={gt => {
            setGypsumBoardThickness(gt);
          }}
          options={[
            { value: '12.7', label: '12.7 mm (1/2")' },
            { value: '16', label: '16 mm (5/8")' },
          ]}
        />
      </QuestionWrapper>

      <div>
        <OcLabel text={t('thermal_calculator.roofs_below_attics.wood_strap_gypsum')} />
        <YesNo
          name={`wood-strapping-${calcId}`}
          value={hasWoodStrapping}
          onChange={val => {
            setHasWoodStrapping(val);
          }}
        />
      </div>

      <div>
        <OcLabel text={t('thermal_calculator.roofs_below_attics.vapour_barrier')} />
        <YesNo
          name={`vapour-barrier-${calcId}`}
          value={hasVapourBarrier}
          onChange={val => {
            setHasVapourBarrier(val);
          }}
        />
      </div>

      <div>
        <OcLabel forId="roof-truss" text={t('thermal_calculator.roofs_below_attics.insulation_above_roof')} />
        <NumberInput
          id={`roof-truss-${calcId}`}
          value={aboveTrussRSI}
          onChange={e => setAboveTrussRSI(e.target.value)}
          placeholder="0"
          max={150}
          style={{ width: '100%', marginTop: 6, padding: '8px 10px' }}
        />
      </div>

      <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
        <CTAButton
          onClick={onCalculate}
          disabled={!hasLocation}
          text={t('thermal_calculator.calculate_r_value')}
          style={{ minWidth: '200px' }}
        />
        <CTAButton
          element="button"
          type="button"
          onClick={onReset}
          text={t('thermal_calculator.reset')}
          style={{
            minWidth: '100px',
            padding: '8px 16px',
            border: '1px solid #ccc',
            background: '#fff',
            color: '#000',
          }}
        />
      </div>
    </Section>
  </>
);
/* eslint-enable react/prop-types */
